"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCompoundParser = void 0;
var tslib_1 = require("tslib");
var shorthands_1 = require("../shorthands");
var setParsedCompoundValue = function (parseMap, node, prop) {
    var e_1, _a;
    if (!Array.isArray(node)) {
        node.parsedValue = parseMap[prop](node.value.text, prop);
        return;
    }
    try {
        for (var node_1 = tslib_1.__values(node), node_1_1 = node_1.next(); !node_1_1.done; node_1_1 = node_1.next()) {
            var innerNode = node_1_1.value;
            setParsedCompoundValue(parseMap, innerNode, prop);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (node_1_1 && !node_1_1.done && (_a = node_1.return)) _a.call(node_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
var createCompoundParser = function (_a) {
    var prop = _a.prop, singleKeywordPart = _a.singleKeywordPart, parts = _a.parts, shorthandOpener = _a.shorthandOpener;
    return function (compound, api) {
        var e_2, _a, e_3, _b;
        var parseMap = {};
        if (singleKeywordPart) {
            parseMap[singleKeywordPart.prop] = singleKeywordPart.parser;
        }
        try {
            for (var parts_1 = tslib_1.__values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
                var part = parts_1_1.value;
                parseMap[part.prop] = part.parser;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var openCompoundAsShorthand = (0, shorthands_1.createShorthandOpener)({
            prop: prop,
            singleKeywordPart: singleKeywordPart,
            parts: parts,
            shorthandOpener: shorthandOpener,
        });
        var opened = openCompoundAsShorthand(compound, api);
        var parsed = tslib_1.__assign({}, opened);
        var props = Object.keys(opened);
        try {
            for (var props_1 = tslib_1.__values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
                var prop_1 = props_1_1.value;
                setParsedCompoundValue(parseMap, parsed[prop_1], prop_1);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (props_1_1 && !props_1_1.done && (_b = props_1.return)) _b.call(props_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return parsed;
    };
};
exports.createCompoundParser = createCompoundParser;
//# sourceMappingURL=compound-parser-utils.js.map